import React from "react"
import { ButtonLink, ScrollButtonLink } from "./"

export const CallToAction = ({ type, text, target, page, colour }) => {
  return type === "Anchor" && text && target ? (
    <>
      <style>
        {`.${colour && text.replace(" ", "")}{
      background: ${colour} !important;
    }
    `}
      </style>
      <ScrollButtonLink
        to={target}
        smooth={true}
        duration={800}
        reversed
        className={colour && text.replace(" ", "")}
      >
        {text}
      </ScrollButtonLink>
    </>
  ) : (type === "Page" || type === "Document") && text && page ? (
    <>
      <style>
        {`.${colour && text.replace(" ", "")}{
      background: ${colour} !important;
    }
    `}
      </style>
      <ButtonLink
        to={`${target ? page?.url + "#" + target : page?.url}`}
        stripHash
        className={colour && text.replace(" ", "")}
      >
        {text}
      </ButtonLink>
    </>
  ) : null
}
